import React, { useState, useEffect } from 'react';
import { Card, Form, Row, Col, ButtonGroup } from 'react-bootstrap';
import { Formik } from 'formik';
import * as yup from 'yup';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { DANGKYDUTUYEN_API, DOTTUYENSINH_API } from '@app/utils/apiUrl';
import { useQuery, useMutation, useQueryClient } from 'react-query';
import { Get, Post } from '@app/utils/httpProvider';
import { messageError, messageToast, status200, styleSelectDefault, objectTrangThaiDangKyDuTuyen, trangThaiDangKyDuTuyenValue, objectGioiTinh, DATE_TIME_REACT_WITHOUT_HOUR_FORMAT, gioiTinh } from '../../../../utils/define';
import { URI_INTERNAL } from '../../../../utils/pathLocations';
import { Button } from '@components';
import { AsyncPaginate } from 'react-select-async-paginate';
import HorizontalFieldsRow from '@app/components/common/HorizontalFieldsRow';
import Editor from '@app/components/editor/Editor';
import moment from 'moment';
import Select from 'react-select';
import DatePicker from 'react-datepicker';

const schema = yup.object().shape({
    dotTuyenSinhId: yup.string().required('Đợt tuyển sinh không được để trống'),
    hoTen: yup.string().required(messageError.emptyMessage).max(255, 'Họ tên tối đa 255 ký tự'),
    canCuocCongDan: yup.string().max(50, 'Căn cước công dân tối đa 50 ký tự'),
    email: yup.string().email('Email không đúng định dạng').max(255, 'Email tối đa 255 ký tự'),
    dienThoai: yup.string().max(50, 'Điện thoại tối đa 50 ký tự')
});

const DangKyDuTuyenAdd = () => {
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(false);

    const addFunc = useMutation((value) =>
        Post(DANGKYDUTUYEN_API.ADD_ITEM, null, value, false)
    );

    const handleCreate = async (values) => {
        setIsLoading(true);
        const model = {
            ...values,
        };

        model.dotTuyenSinhId =
            values.dotTuyenSinhId === '' ||
                values.dotTuyenSinhId === 'null' ||
                values.dotTuyenSinhId === undefined
                ? ''
                : values.dotTuyenSinhId.value;
        
        model.gioiTinh = values.gioiTinh.value;
        model.trangThaiDangKyDuTuyen = values.trangThaiDangKyDuTuyen.value;

        addFunc.mutate(model, {
            onSuccess: (res) => {
                if (res.status !== status200) {
                    toast.error(messageToast.messageToastCreateError);
                } else {
                    setIsLoading(false);
                    toast.success(messageToast.messageToastCreateSuccess);
                    history.push(URI_INTERNAL.DANGKYDUTUYEN_PATH);
                }
            },
            onError: (res) => {
                toast.error(
                    res.message || 'Đã có lỗi xảy ra, vui lòng thử lại !'
                );
            }
        });
    };

    const loadOptionsDotTuyenSinh = async (search, loadedOptions, { page }) => {
        const pageSize = 10;
        const res = await Get(DOTTUYENSINH_API.GET_PAGING, null, {
            PageIndex: page,
            PageSize: pageSize,
            Keyword: search // pass the input text to filter server-side
        });

        const data = res.data || [];
        const options = data.map((x) => ({
            label: `${x.maDot} - ${x.tenDot}`,
            value: x.id
        }));

        // assume your API returns total count or a flag for more pages
        const hasMore = data.length === pageSize;
        return {
            options,
            hasMore,
            additional: { page: page + 1 }
        };
    };

    return (
        <Card>
            <Card.Header as="h5">Thêm mới đăng ký dự tuyển</Card.Header>
            <Card.Body>
                <Formik
                    validationSchema={schema}
                    onSubmit={(values) => handleCreate(values)}
                    initialValues={{
                        dotTuyenSinhId: '',
                        accountHocVienInfoId: null,
                        hoTen: '',
                        ngaySinh: '',
                        gioiTinh: gioiTinh.nam.toString(),
                        canCuocCongDan: '',
                        email: '',
                        dienThoai: '',
                        donViCongTac: '',
                        diaChi: '',
                        ngayDangKy: moment().format('YYYY-MM-DDTHH:mm'),
                        trangThaiDangKyDuTuyen: trangThaiDangKyDuTuyenValue.moiDangKy.toString(),
                        ghiChu: ''
                    }}
                >
                    {({ handleSubmit, handleChange, values, errors, setFieldValue }) => (
                        <Form noValidate onSubmit={handleSubmit}>
                            <HorizontalFieldsRow
                                fields={[
                                    {
                                        label: 'Họ tên',
                                        name: 'hoTen',
                                        value: values.hoTen,
                                        onChange: handleChange,
                                        isInvalid: errors.hoTen,
                                        error: errors.hoTen,
                                        required: true
                                    },
                                    {
                                        label: 'Căn cước công dân',
                                        name: 'canCuocCongDan',
                                        value: values.canCuocCongDan,
                                        onChange: handleChange,
                                        isInvalid: errors.canCuocCongDan,
                                        error: errors.canCuocCongDan
                                    },
                                ]}
                            />
                            <HorizontalFieldsRow
                                fields={[
                                    {
                                        label: 'Email',
                                        name: 'email',
                                        type: 'email',
                                        value: values.email,
                                        onChange: handleChange,
                                        isInvalid: errors.email,
                                        error: errors.email
                                    },
                                    {
                                        label: 'Điện thoại',
                                        name: 'dienThoai',
                                        value: values.dienThoai,
                                        onChange: handleChange,
                                        isInvalid: errors.dienThoai,
                                        error: errors.dienThoai
                                    },
                                ]}
                            />
                            <Row>
                                <Col md={6}>
                                    <Form.Group as={Row} className="mb-3">
                                        <Form.Label className="col-sm-3 col-form-label">
                                            Giới tính
                                        </Form.Label>
                                        <Col sm="9">
                                            <Select
                                                name="gioiTinh"
                                                id="gioiTinh"
                                                placeholder="Giới tính"
                                                value={values.gioiTinh}
                                                onChange={(selectedOption) => {
                                                    const event = {
                                                        target: {
                                                            name: 'gioiTinh',
                                                            value: selectedOption
                                                        }
                                                    };
                                                    handleChange(event);
                                                }}
                                                options={objectGioiTinh}
                                            />
                                            <div
                                                style={{
                                                    display: 'block',
                                                    color: '#dc3545'
                                                }}
                                                className="invalid-feedback"
                                            >
                                                {errors.gioiTinh}
                                            </div>
                                        </Col>
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group as={Row} className="mb-3">
                                        <Form.Label className="col-sm-3 col-form-label">
                                            Ngày sinh
                                        </Form.Label>
                                        <Col sm="9">
                                            <DatePicker
                                                locale="vi"
                                                selected={values.ngaySinh}
                                                onChange={(date) => {
                                                    setFieldValue(
                                                        'ngaySinh',
                                                        date,
                                                        true
                                                    );
                                                }}
                                                dateFormat={
                                                    DATE_TIME_REACT_WITHOUT_HOUR_FORMAT
                                                }
                                                showMonthDropdown
                                                showYearDropdown
                                                // showMonthYearPicker
                                                // showFullMonthYearPicker
                                                className="form-control"
                                            />
                                        </Col>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <HorizontalFieldsRow
                                fields={[
                                    {
                                        label: 'Đơn vị công tác',
                                        name: 'donViCongTac',
                                        value: values.donViCongTac,
                                        onChange: handleChange
                                    },
                                    {
                                        label: 'Địa chỉ',
                                        name: 'diaChi',
                                        value: values.diaChi,
                                        onChange: handleChange
                                    },
                                ]}
                            />
                            <Row>
                                <Col md={6}>
                                    <Form.Group as={Row} className="mb-3">
                                        <Form.Label className="col-sm-3 col-form-label">
                                            Trạng thái đăng ký dự tuyển
                                        </Form.Label>
                                        <Col sm="9">
                                            <Select
                                                name="trangThaiDangKyDuTuyen"
                                                id="trangThaiDangKyDuTuyen"
                                                placeholder="Trạng thái đăng ký dự tuyển"
                                                value={values.trangThaiDangKyDuTuyen}
                                                onChange={(selectedOption) => {
                                                    const event = {
                                                        target: {
                                                            name: 'trangThaiDangKyDuTuyen',
                                                            value: selectedOption
                                                        }
                                                    };
                                                    handleChange(event);
                                                }}
                                                options={objectTrangThaiDangKyDuTuyen}
                                            />
                                            <div
                                                style={{
                                                    display: 'block',
                                                    color: '#dc3545'
                                                }}
                                                className="invalid-feedback"
                                            >
                                                {errors.trangThaiDangKyDuTuyen}
                                            </div>
                                        </Col>
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group as={Row} className="mb-3">
                                        <Form.Label className="col-sm-3 col-form-label">
                                            Ngày đăng ký
                                        </Form.Label>
                                        <Col sm="9">
                                            <DatePicker
                                                locale="vi"
                                                selected={values.ngayDangKy}
                                                onChange={(date) => {
                                                    setFieldValue(
                                                        'ngayDangKy',
                                                        date,
                                                        true
                                                    );
                                                }}
                                                dateFormat={
                                                    DATE_TIME_REACT_WITHOUT_HOUR_FORMAT
                                                }
                                                showMonthDropdown
                                                showYearDropdown
                                                // showMonthYearPicker
                                                // showFullMonthYearPicker
                                                className="form-control"
                                            />
                                        </Col>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={6}>
                                    <Form.Group as={Row} className="mb-3">
                                        <Form.Label className="col-sm-3 col-form-label">
                                            Đợt tuyển sinh <span className="text-danger">*</span>
                                        </Form.Label>
                                        <Col sm="9">
                                            <AsyncPaginate
                                                name="dotTuyenSinhId"
                                                id="dotTuyenSinhId"
                                                placeholder="Chọn đợt tuyển sinh"
                                                value={values.dotTuyenSinhId}
                                                loadOptions={loadOptionsDotTuyenSinh}
                                                styles={styleSelectDefault}
                                                isClearable
                                                onChange={(selectedOption) => {
                                                    // const event = {
                                                    //     target: {
                                                    //         name: 'accountPatients',
                                                    //         value: selectedOption
                                                    //     }
                                                    // };
                                                    // setAccountHisId(event);
                                                    setFieldValue(
                                                        'dotTuyenSinhId',
                                                        selectedOption,
                                                        true
                                                    );
                                                }}
                                                additional={{
                                                    page: 1
                                                }}
                                            />
                                            <div
                                                style={{
                                                    display: 'block',
                                                    color: '#dc3545'
                                                }}
                                                className="invalid-feedback"
                                            >
                                                {errors.dotTuyenSinhId}
                                            </div>
                                        </Col>
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group as={Row} className="mb-3">
                                        <Form.Label className="col-sm-2 col-form-label">
                                            Ghi chú
                                        </Form.Label>
                                        <Col sm="10">
                                            <Col sm="10">
                                                <Editor
                                                    name="ghiChu"
                                                    value={values.ghiChu}
                                                    onChange={(value) => {
                                                        setFieldValue(
                                                            'ghiChu',
                                                            value
                                                        );
                                                    }}
                                                />
                                            </Col>
                                        </Col>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Form.Group as={Row} className="mb-3">
                                <Col md={{ span: 10, offset: 2 }}>
                                    <ButtonGroup className="mb-2">
                                        <Button type="submit" theme="primary" disabled={isLoading}>
                                            Thêm
                                        </Button>
                                        &nbsp;&nbsp;&nbsp;
                                        <Button onClick={() => history.push(URI_INTERNAL.DANGKYDUTUYEN_PATH)} theme="secondary">
                                            Hủy
                                        </Button>
                                    </ButtonGroup>
                                </Col>
                            </Form.Group>
                        </Form>
                    )}
                </Formik>
            </Card.Body>
        </Card>
    );
};

export default DangKyDuTuyenAdd;